import React, { useState, useRef, KeyboardEvent } from 'react';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import './AiChat.css';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setMessage('');
    textareaRef.current?.focus();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="ai-chat-input">
      <div className="ai-chat-input__field">
        <InputTextarea
          ref={textareaRef}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask me anything about RLCA..."
          autoResize
          rows={1}
          disabled={disabled}
          className="ai-chat-input__textarea"
        />
      </div>
      <div className="ai-chat-input__actions">
        <Button
          icon="pi pi-send"
          onClick={handleSend}
          disabled={!message.trim() || disabled}
          className="ai-chat-input__send-btn"
          aria-label="Send message"
        />
      </div>
    </div>
  );
};
